export { default } from './EditorialListAndImage';
